import { stripLeadingSlash } from 'history/PathUtils';

/**
 * Helper function to decorate a given path with a stitchClientAppId prefix if
 * the stitchClientAppId is set and does not already exist in the path.
 *
 * @param {String} path - the pathname to decorate
 * @param {String} stitchClientAppId - the unique identifier for the stitch app.
 * @returns {String} - the decorated pathname
 **/
const decoratePathWithStitchClientAppId = (path, stitchClientAppId = null) => {
  return stitchClientAppId && path.includes(stitchClientAppId) === false
    ? `/${stitchClientAppId}/${stripLeadingSlash(path)}`
    : path;
};

export default decoratePathWithStitchClientAppId;
export { decoratePathWithStitchClientAppId };
